<template>
  <BaseCardV2
    :titre="$vuetify.breakpoint.mobile || loading.evolutionAdherent || erreur.evolutionAdherent ? 'Mon rendement moyen' : ''"
    class="pa-2"
  >
    <div
      class="mb-2"
    >
      <BaseLoader v-if="loading.evolutionAdherent" />
      <BaseMessageServerError
        v-if="erreur.evolutionAdherent || erreur.evolutionAdherent"
        class="mx-5 my-2"
      />
      <div
        v-if="!loading.evolutionAdherent && !erreur.evolutionAdherent"
        class="d-flex"
        :class="$vuetify.breakpoint.mobile ? 'flex-column' : 'justify-space-between mx-3'"
      >
        <div
          v-if="!$vuetify.breakpoint.mobile"
          class="align-self-center font-weight-bold secondary--text"
          :class="$vuetify.breakpoint.mobile ? 'titre-h4' : 'titre-h3'"
        >
          Mon rendement moyen
        </div>
        <div
          v-if="evolutionRendementNumtiers.rendementEnQuintauxParHectare != null"
          class="d-flex align-self-center"
          :class="$vuetify.breakpoint.mobile ? 'flex-column' : ''"
        >
          <div class="d-flex">
            <div class="chiffre-xxl secondary--text align-self-center">
              {{ rendementAffiche |roundNumber(precisionRendement) }}
            </div>
            <div class="titre-h1 secondary--text align-self-center ml-2">
              {{ uniteRendement }}
            </div>
            <v-tooltip
              v-if="mentionRendement"
              bottom
            >
              <template v-slot:activator="{ on }">
                <v-icon
                  class="align-self-center ml-1"
                  color="primary"
                  small
                  v-on="on"
                >
                  mdi-information-outline
                </v-icon>
              </template>
              <span class="texte white--text">{{ mentionRendement }}</span>
            </v-tooltip>
          </div>
          <div
            class="align-self-center ml-5"
            :class="$vuetify.breakpoint.mobile ? 'mt-3 mb-5' : ''"
          >
            <BaseEvolutionWithInfo
              v-if="evolutionRendementNumtiers.evolutionRendementEnPourcentage != null"
              :evolution-value="evolutionRendementNumtiers.evolutionRendementEnPourcentage"
              :values="rendementParAnneeAffiche"
              :unite="uniteRendement"
              :precision="precisionRendement"
            />
          </div>
        </div>
        <div
          v-else
          class="align-self-center d-flex"
          :class="$vuetify.breakpoint.mobile ? 'flex-column my-10' : ''"
        >
          <img
            src="@/assets/no-cultures.svg"
            alt="no-cultures"
            class="align-self-center mr-5"
            :class="$vuetify.breakpoint.mobile ? '' : 'no-cultures align-center'"
          >
          <div class="align-self-center intro texte-gris-fonce">
            Retrouvez la synthèse de vos produits
          </div>
        </div>
        <div v-if="evolutionRendementNumtiers.rendementEnQuintauxParHectare != null">
          <div
            class="d-flex"
            :class="$vuetify.breakpoint.mobile ? 'mr-16' : ''"
          >
            <div
              v-if="!erreur.evolutionGroupe"
              class="align-self-center"
              :class="$vuetify.breakpoint.mobile ? 'mr-2' : 'position-indicateur-jauge'"
            >
              <UserIndicatorJauge
                :chargement="loading.evolutionGroupe"
                :data="{
                  value: positionJaugeGroupe(repartitionRendementGroupe?.codePositionDuNumtiers)
                }"
                :data-groupe="valeurMoyenneDuGroupeAffichee"
                :unite="uniteRendement"
                :precision="precisionRendement"
                :is-parametres-exploitation-incomplet="!isParametresExploitationComplet"
                :negative-color="repartitionRendementGroupe?.valeurMoyenneDuGroupe && isParametresExploitationComplet ? '#ec6608' : 'grey'"
                :positive-color="repartitionRendementGroupe?.valeurMoyenneDuGroupe && isParametresExploitationComplet ? '#01713c' : 'grey'"
              />
            </div>
            <AgrButton
              color="primary"
              large
              :block="$vuetify.breakpoint.mobile"
              class="align-self-center"
              :class="$vuetify.breakpoint.mobile ? '' : ' position-btn-plus-infos'"
              @click="openModaleDetail"
            >
              <v-icon>mdi-magnify-plus-outline</v-icon>
              <span class="action text-truncate white--text">Plus d'infos</span>
            </AgrButton>

            <InformationAbonnementModal
              v-if="isOpenModalAideInformationAbonnement"
              :is-open-modal-information-abonnement="isOpenModalAideInformationAbonnement"
              code-feature="PRIX_EQUILIBRE_CULTURE"
              texte="Déterminez votre prix d'équilibre par culture en €/t grâce à un expert, pour vous aider dans votre commercialisation."
              titre="Mesurer la rentabilité technique et économique"
              :is-conseiller-pv-affiche="!isAbonneCulturial"
              @close="isOpenModalAideInformationAbonnement = false"
            />
          </div>
        </div>
        <div
          v-else
          class="mt-auto mb-3 mx-5"
          @click="onToPageMesCultures"
        >
          <AgrButton
            color="primary "
            block
            large
            class="align-self-center"
          >
            <span class="action text-truncate white--text">Renseigner mes rendements</span>
          </AgrButton>
        </div>
      </div>
    </div>
    <v-dialog
      v-model="isOpenModalDetailRendement"
      :scrim="false"
      scrollable
      :width="$vuetify.breakpoint.mobile ? '' : '70%'"
      @click:outside="isOpenModalDetailRendement = false"
    >
      <DetailAnalyseModal
        :titre="'Mon rendement moyen'"
        @close="isOpenModalDetailRendement = false"
      >
        <div slot="baseCardHelpContent">
          <v-row
            no-gutters
            class="justify-center px-2 mb-2"
          >
            <v-col
              cols="12"
              md="6"
              class="pa-2"
            >
              <ComparaisonRendement
                :annee-recolte-selected="anneeRecolteSelected"
                :type-culture="typeCulture"
                :code-graine-rs3-selected="codeGraineRs3Selected"
                :loading="loading.comparaisonRendement"
              />
            </v-col>
            <v-col
              cols="12"
              md="6"
              class="pa-2"
            >
              <EvolutionRendements
                :annee-recolte-selected="anneeRecolteSelected"
                :type-culture="typeCulture"
                :code-graine-rs3-selected="codeGraineRs3Selected"
                :loading="loading.evolutionRendement"
                :has-region-selected="hasRegionSelected"
              />
            </v-col>
          </v-row>
          <div
            class="d-flex justify-center asterix py-3"
          >
            * Evolution par rapport à l’année précédente
          </div>
        </div>
      </DetailAnalyseModal>
    </v-dialog>
    <InfoModal
      v-if="isOpenModaleInfosManquantes"
      confirm-text="Renseigner les infos"
      titre="Infos manquantes"
      :is-open-modale-infos-manquantes="isOpenModaleInfosManquantes"
      @close="isOpenModaleInfosManquantes = false"
      @confirm="onPageMonCompte()"
    >
      <InfoManquanteContentModal />
    </InfoModal>
  </BaseCardV2>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import { AgrButton } from '@agrial/ui'
import BaseCardV2 from '@/components/card/base-card-v2.vue'
import BaseLoader from '@/components/common/base-loader.vue'
import BaseMessageServerError from '@/components/common/base-message-server-error.vue'
import BaseEvolutionWithInfo from '@/components/common/base-evolution-with-info.vue'
import UserIndicatorJauge from '@/components/chart/v2/user-indicator-jauge.vue'
import ComparaisonRendement from './comparaison-rendement.vue'
import EvolutionRendements from './evolution-rendements.vue'
import DetailAnalyseModal from '@/views/outils-analyse/components/modal/detail-analyse-modal.vue'
import InfoModal from '@/components/modal/info-modal.vue'
import InfoManquanteContentModal from '@/components/modal/info-manquante-content-modal.vue'
import { convertirRendement, mentionRendement, precisionRendement, uniteRendement } from '@/utils/rendement'

export default {
  name: 'RendementMoyen',
  components: {AgrButton, BaseLoader, BaseCardV2, BaseEvolutionWithInfo, BaseMessageServerError, ComparaisonRendement, EvolutionRendements, DetailAnalyseModal,InfoModal, InfoManquanteContentModal, UserIndicatorJauge },
  props: {
    codeGraineRs3Selected: {
      type: String,
      default: null
    },
    anneeRecolteSelected: {
      type: String,
      default: null
    },
    hasRegionSelected: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      loading: {
        evolutionAdherent: false,
        evolutionGroupe: false,
        evolutionRendement: false,
        comparaisonRendement: false
      },
      erreur: {
        evolutionAdherent: false,
        evolutionGroupe: false,
        evolutionRendement: false,
        comparaisonRendement: false
      },
      isOpenModaleInfosManquantes: false,
      isOpenModalDetailRendement: false,
      isOpenModalAideInformationAbonnement: false
    }
  },

  computed: {
    ...mapGetters({
      abonnements: 'adherent/abonnements',
      filtresAdherent: 'filtresComparaison/filtresAdherent',
      evolutionRendementNumtiers: 'rendement/evolutionRendementNumtiers',
      repartitionRendementGroupe: 'rendement/repartitionRendementGroupe',
      cultures: 'culture/cultures',
      isParametresExploitationComplet: 'parametresExploitation/isParametresExploitationComplet',
    }),
    
    isAbonneCulturial () {
      return this.abonnements.culturialAbonne
    },
    typeCulture () {
      return this.cultures.find(c => c.typeCulture?.code === this.codeGraineRs3Selected)?.typeCulture
    },
    uniteRendement () {
      return uniteRendement(this.typeCulture)
    },
    precisionRendement () {
      return precisionRendement(this.typeCulture)
    },
    mentionRendement () {
      return mentionRendement(this.typeCulture)
    },
    rendementAffiche () {
      return convertirRendement(this.evolutionRendementNumtiers.rendementEnQuintauxParHectare, this.typeCulture)
    },
    rendementParAnneeAffiche () {
      const rendementParAnnee = this.evolutionRendementNumtiers.rendementParAnnee

      if (rendementParAnnee == null) {
        return null
      }

      return Object.entries(rendementParAnnee).reduce((accumulateur, [annee, rendement]) => {
        accumulateur[annee] = convertirRendement(rendement, this.typeCulture)
        return accumulateur
      }, {})
    },
    valeurMoyenneDuGroupeAffichee () {
      return convertirRendement(this.repartitionRendementGroupe?.valeurMoyenneDuGroupe, this.typeCulture)
    }
  },

  watch: {
    anneeRecolteSelected () {
      this.loadEvolutionAdherent()
      this.loadEvolutionGroupe()
    },
    codeGraineRs3Selected () {
      this.loadEvolutionAdherent()
      this.loadEvolutionGroupe()
    },
    filtresAdherent () {
      this.loadEvolutionGroupe()
    }
  },

  created () {
    this.loadEvolutionAdherent()
    this.loadEvolutionGroupe()
  },

  methods: {
    ...mapActions({
      updateCodeGraineActive: 'application/updateCodeGraineActive',
      getEvolutionRendementNumtiers: 'rendement/getEvolutionRendement',
      getEvolutionRendementGroupe: 'rendement/getResumeRepartitionParQuartileRendementGroupe',
      getGrapheComparaisonCultureRendementMoyens:'rendement/getGrapheComparaisonCultureRendementMoyens',
      getRendementsByNumtiersAndRecolteAndGraine: 'rendement/getRendementsByNumtiersAndRecolteAndGraine',
      getRendementsByNumtiersAndRecolteAndGraineGroupe: 'rendement/getRendementsByNumtiersAndRecolteAndGraineGroupe',
    }),
    loadEvolutionAdherent () {
      this.loading.evolutionAdherent = true
      this.erreur.evolutionAdherent = false
      this.getEvolutionRendementNumtiers(this.codeGraineRs3Selected)
        .catch(() => this.erreur.evolutionAdherent = true)
        .finally(() => this.loading.evolutionAdherent = false)
    },
    loadEvolutionGroupe () {
      this.loading.evolutionGroupe = true
      this.erreur.evolutionGroupe = false
      this.getEvolutionRendementGroupe(this.codeGraineRs3Selected)
        .catch(() => this.erreur.evolutionGroupe = true)
        .finally(() => this.loading.evolutionGroupe = false)
    },
    openModaleDetail () {
      if (this.isParametresExploitationComplet) {
      this.isOpenModalDetailRendement = true
      this.loadRepartitionRendement()
      this.loadEvolutionRendements()
      } else {
        this.isOpenModaleInfosManquantes = true
      }
    },
    loadEvolutionRendements () {
      this.erreur.evolutionRendement = false
      this.loading.evolutionRendement = true
      Promise.all([
        this.getRendementsByNumtiersAndRecolteAndGraine(this.codeGraineRs3Selected),
        this.getRendementsByNumtiersAndRecolteAndGraineGroupe(this.codeGraineRs3Selected)
        ])
        .catch(() => {
          this.erreur.evolutionRendement = true
        })
        .finally(() => {
          this.loading.evolutionRendement = false
        })
    },
    loadRepartitionRendement () {
      this.erreur.comparaisonRendement = false
      this.loading.comparaisonRendement = true
      this.getGrapheComparaisonCultureRendementMoyens(this.codeGraineRs3Selected)
        .catch(() => {
          this.erreur.comparaisonRendement = true
        })
        .finally(() => {
          this.loading.comparaisonRendement = false
        })
    },
    onToPageMesCultures () {
      this.updateCodeGraineActive(this.codeGraineRs3Selected)
      this.$router.push({name: 'main.mes-cultures', params:{isModalCultureOpen: true}})
    },
    onPageMonCompte () {
      this.isOpenModaleInfosManquantes = false
      this.$router.push({ name: 'main.compte' })
    },
    positionJaugeGroupe (codePosition) {
      let result = null
      switch (codePosition) {
        case 'QUARTILE_SUP':
          result = 'positive'
          break
        case 'QUARTILE_INF':
          result = 'negative'
          break
        case 'MOYENNE':
          result = 'center'
          break
      }
      return result
    }
  }
}

</script>

<style lang="scss" scoped>
.no-cultures {
  width: 20%;
}
.w-250 {
  width: 250px;
}
.position-indicateur-jauge {
  position: absolute;
  bottom: 15px;
  right: 180px;
}
.position-btn-plus-infos {
  position: absolute;
  bottom: 25px;
  right: 15px;
}
.asterix {
  font-size: 0.875rem;
  color: var(--gris-fonce);
}
</style>
